import { render } from "./RecipeReloadExplanation.vue?vue&type=template&id=4e4fa6e9&scoped=true"
import script from "./RecipeReloadExplanation.vue?vue&type=script&lang=js"
export * from "./RecipeReloadExplanation.vue?vue&type=script&lang=js"

import "./RecipeReloadExplanation.vue?vue&type=style&index=0&id=4e4fa6e9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4fa6e9"]])

export default __exports__